<template>
  <div id="app">
    <h2>"The more articulate one is, the more dangerous words become"</h2>
    <h4>Practice this daily and become a titan of influence and capability.</h4>
    <div style="border-style: ridge ; border-radius: 25px; padding-bottom: 10px;">
      <TextRecorder :question="texts[current].question" :adjectives="texts[current].adjectives" :index="current" :stage="stage" :total="texts.length"/>
      <br>

      <button style="width: auto; height: 50px; margin: auto; font-size: 24px; text-align: center; border-radius: 25px;" @click="next_stage" v-if="stage < 2">Next Step</button>
      <button style="width: auto; height: 50px; margin: auto; font-size: 24px; text-align: center; border-radius: 25px;" @click="done" v-else>Done</button>


    </div>
    
    <br>

    <button style="width: auto; height: 50px; margin: auto; font-size: 24px; text-align: center; border-radius: 25px;" @click="next_text" >Next Topic</button>
    <!-- <button style="width: auto; height: 100px; margin: auto; font-size: 24px; text-align: center;" disabled @click="done" v-else>Next</button> -->
  </div>
</template>

<script>
import TextRecorder from "./components/TextRecorder";

export default {
  name: "App",
  components: {
    TextRecorder
  },
  data() {
    return {
      texts: [
          {
              "question": "Describe the lunch you had today. Detail the sight, sound, and smell of the meal.",
              "adjectives": ["colorful", "sizzling", "fragrant"]
          },
          {
              "question": "What is your favorite hobby? Explain why you got into this hobby.",
              "adjectives": ["enjoyable", "rewarding", "engaging"]
          },
          {
              "question": "Give a 30-second elevator pitch of your favorite movie.",
              "adjectives": ["captivating", "thrilling", "innovative"]
          },
          {
              "question": "Outline a typical day in your profession. Highlight the main activities and challenges.",
              "adjectives": ["hectic", "demanding", "fulfilling"]
          },
          {
              "question": "Recall a recent book you read. What were your thoughts on the plot and characters?",
              "adjectives": ["complex", "intriguing", "flawed"]
          },
          {
              "question": "Explain a scientific concept that fascinates you.",
              "adjectives": ["complex", "revolutionary", "fundamental"]
          },
          {
              "question": "Share a memorable travel experience. What made it unforgettable?",
              "adjectives": ["breathtaking", "nostalgic", "adventurous"]
          },
          {
              "question": "Describe your ideal weekend. What activities would you include?",
              "adjectives": ["relaxing", "exciting", "satisfying"]
          },
          {
              "question": "What is a skill you recently learned? Why did you decide to learn it?",
              "adjectives": ["useful", "challenging", "rewarding"]
          },
          {
              "question": "Discuss a movie that deeply impacted you. What themes stood out?",
              "adjectives": ["profound", "disturbing", "inspiring"]
          },
          {
              "question": "Describe a piece of art that you find beautiful. What captures your attention?",
              "adjectives": ["stunning", "thought-provoking", "exquisite"]
          },
          {
              "question": "What's a childhood memory that still makes you smile?",
              "adjectives": ["sweet", "vivid", "endearing"]
          },
          {
              "question": "If you could meet any historical figure, who would it be and why?",
              "adjectives": ["influential", "controversial", "visionary"]
          },
          {
              "question": "Describe your favorite season and why you love it.",
              "adjectives": ["cozy", "vibrant", "tranquil"]
          },
          {
              "question": "What is a personal challenge you've overcome recently?",
              "adjectives": ["daunting", "enlightening", "gratifying"]
          },
          {
              "question": "Explain your favorite sport and what makes it exciting for you.",
              "adjectives": ["dynamic", "exhilarating", "competitive"]
          },
          {
              "question": "Share a recipe that you love. What makes it special?",
              "adjectives": ["delicious", "timeless", "comforting"]
          },
          {
              "question": "What is a significant trend in your field of work or study?",
              "adjectives": ["emerging", "disruptive", "pivotal"]
          },
          {
              "question": "Describe an event that changed your perspective on life.",
              "adjectives": ["transformative", "eye-opening", "pivotal"]
          },
          {
              "question": "What hobby or activity have you always wanted to try but haven't yet?",
              "adjectives": ["exciting", "intriguing", "daunting"]
          }
      ],
      current: 0,
      stage: 0
    };
  },
  methods: {
    next_text() {
      this.stage = 0
      this.current++;
      this.current =  this.current%(this.texts.length)
    },
    next_stage() {
      this.stage++;
    },
    done() {
      this.stage = 0
      console.log("done");
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
